module.exports = __webpack_public_path__ + "img/addressBook.7dcaeaeb.svg";